<template>
  <auth-layout pageClass="register-page">
    <div class="row justify-content-center">
      <div class="col-md-4">
        <div class="media">
          <div class="media-left">
            <div class="icon">
              <i class="nc-icon nc-key-25"></i>
            </div>
          </div>
          <div class="media-body">
            <h4>Recuperação de Senha</h4>
            <p>Insira nome de usuário para que possamos enviar uma nova senha.</p>
          </div>
        </div>
        <form method="#" action="#">
          <card class="card-plain">
            <div>
              <fg-input placeholder="Nome de Usuário" v-model="model.username"></fg-input>
            </div>
            <div class="text-center">
              <button
                type="button"
                @click="submit"
                class="btn btn-fill btn-default btn-neutral btn-wd"
              >OK</button>
            </div>
          </card>
        </form>
      </div>
    </div>
  </auth-layout>
</template>
<script>
import { FadeRenderTransition } from "src/components/index";
import AuthLayout from "./AuthLayout.vue";

export default {
  components: {
    FadeRenderTransition,
    AuthLayout
  },
  created() {
    if (this.$store.state.auth.authenticated) {
      this.$router.replace({ name: "Geral" });
    }
  },
  data() {
    return {
      model: {
        username: ""
      }
    };
  },
  methods: {
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      document.body.classList.remove("off-canvas-sidebar");
    },
    notifySuccess() {
      this.$notify({
        message: "Sucesso</br>E-mail enviado!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "success"
      });
    },
    notifyError() {
      this.$notify({
        message: "Erro</br>E-mail não encontrado!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "danger"
      });
    },
    async submit() {
      try {
        await this.$store.dispatch("auth/recoverPassword", {
          item: this.model
        });
        this.notifySuccess();
      } catch (err) {
        this.notifyError();
      }
    }
  },
  beforeDestroy() {
    this.closeMenu();
  }
};
</script>
<style>
</style>
